import {
  IconFileDownload,
  SimpleTableToolbar,
  SimpleTableToolbarButtons,
  SimpleTableHeaderButton,
  SearchInput,
  INPUT_SIZES,
  IconButton,
  EXPAND_BEHAVIORS,
  Grid,
  Row,
  Column,
  IconFilterList
} from 'cdk-radial';
import { useState, useEffect, useRef } from 'react';
import { FormattedMessage } from 'react-intl';
import { StyledSearch, StyledSimpleTableTitle ,FilterMultiSelectChip,FilterDateRangePickerChips} from './styled';
import SearchableDropdown from '../../common/SearchableDropdown';
import useUserInfo from '../../hooks/useUserInfo';
import { createAccountObjects, getDefaultStore } from '../../utils/utils';
import { useAppState } from '../../store';
import moment, { Moment } from 'moment';



export type TableToolbarType = {
  searchedValue: string;
  handleChange: (searchValue: string) => void;
  handleDateDataChange: (startDate: Moment | null, endDate : Moment|null) => void;
  onDateClear: () => void;
  handleStatusFilter: (FilterValues: []) => void;
  handleImportantFilter:(FilterValues:[]) =>void;
  selectedStatus: string[];
  onDownloadCSV: () => void;
  selectedFlag:string[];
};
const TableToolbar = ({
  searchedValue,
  handleChange,
  handleDateDataChange,
  onDateClear,
  handleStatusFilter,
  selectedStatus,
  onDownloadCSV,
  selectedFlag,
  handleImportantFilter,
}: TableToolbarType): JSX.Element => {
  const [isExpanded, setExpanded] = useState<boolean>(false);
  const { selectedGroup, setSelectedGroup,dateTo ,setDateTo,dateFrom,setDateFrom } = useAppState();
 
  const handleDateChange = ({
    endDate: momentEndDateObject,
    startDate: momentStartDateObject
  }: {
    endDate: Moment;
    startDate: Moment;
  }) => {
    if (momentEndDateObject || momentStartDateObject) {
      if (momentStartDateObject){
      setDateFrom(momentStartDateObject);   
      }  
      if (momentEndDateObject){
      setDateTo(momentEndDateObject);
      }
         
    } 
  };

  useEffect(() => {     
    handleDateDataChange(dateFrom,dateTo);
  }, [dateFrom,dateTo]);

 

  useEffect(() => {
    if(!(dateFrom && dateTo)){
    const today = moment();
    const last30Days = today.clone().subtract(30, 'days');
    setDateFrom(last30Days);
    setDateTo(today);
    }
    handleDateDataChange(dateFrom,dateTo);
    
  }, []);


  const options = [
    { value: 'Success', label: 'Success' },
    { value: 'Failed', label: 'Failed' },
    { value: 'In-Progress', label: 'In-Progress' },
    { value: 'Partial Success', label: 'Partial Sucess' }
  ];

  const importantOptions = [
    { value: 'Yes', label: 'Yes' },
    { value: 'No', label: 'No' }
  ];

 
  const [defaultLogOnDetails, setDefaultLogOnDetails] = useState([]);
  const searchRef = useRef<HTMLElement>(null);
  const { userInfo, isFetching } = useUserInfo();

  useEffect(() => {
    if (!isFetching) {
      const defaultLogOnListTemp: any = createAccountObjects(userInfo);
      console.log(JSON.stringify(defaultLogOnListTemp))
      setDefaultLogOnDetails(defaultLogOnListTemp);
      let defaultStore: any = getDefaultStore(userInfo);
      if (!defaultStore?.isDefaultStore && defaultLogOnListTemp?.length > 0) {
        defaultStore = defaultLogOnListTemp[0];
      }
      if( selectedGroup.groupName.label.length == 0 )
      setSelectedGroup(defaultStore);    
    }
  }, [isFetching]);



  useEffect(() => {
    if (!searchRef?.current) {
      setExpanded(true);
    }
  }, []);
  return (
    <SimpleTableToolbar  style={{ padding: "8px" }}>
      <Grid max-height="40px">
        <Row>
          <Column l={4} m={12} s={12} xl={4} xs={12}>
            <div style={{ display: 'flex', justifyContent: 'flex-start' }}>
              <StyledSimpleTableTitle data-testid="dashboard-record-count">
                <FormattedMessage
                  description="List of Order Transmissions"
                  defaultMessage="List of Order Transmissions"
                />
              </StyledSimpleTableTitle>
            </div>
          </Column>
          <Column l={8} m={12} s={12} xl={8} xs={12}>
            <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
              <SimpleTableToolbarButtons>
                <SimpleTableHeaderButton>
                  <StyledSearch>
                    <SearchInput
                      ref={searchRef}
                      clearButtonLabel="clearButtonLabel"
                      id="search-input-expanded2"
                      isAlwaysExpanded={isExpanded}
                      expandBehavior={EXPAND_BEHAVIORS.SLIDE_LEFT as string}
                      name="search-input-expanded2"
                      onChange={handleChange}
                      size={INPUT_SIZES.STANDARD as string}
                      value={searchedValue}
                      dataTestId="mdashboard-search"
                      onClick={() => {
                        setExpanded(false);
                      }}
                    />
                  </StyledSearch>
                </SimpleTableHeaderButton>
                <SimpleTableHeaderButton>
                  <IconButton
                    icon={<IconFileDownload />}
                    text={
                      <FormattedMessage
                        defaultMessage="Download"
                        description="Download"
                      />
                    }
                    data-testid="btn-download-dashboard2"
                    onClick={onDownloadCSV}
                  />
                </SimpleTableHeaderButton>

              </SimpleTableToolbarButtons>
            </div>
          </Column>
        </Row>
        <Row>
          <Column l={6} m={6} s={12} xl={12} xs={12}>
            <div style={{ display: 'flex', justifyContent: 'flex-start' }}>
              <SearchableDropdown
                id="input-Group"
                label="Group"
                defaultOptions={defaultLogOnDetails}
                setSelectedOption={(option: any) => {
                  setSelectedGroup(option);
                }}
                selectedOption={selectedGroup.groupName}
                isRequired={true}
              />
               <FilterDateRangePickerChips
              dataTestId="date-range-filter"
              data-testId="date-range-filter"
              allowDaysInPast
              minimumNights={1}
              endDate={dateTo ? moment(dateTo) : null}
              id="date-range-filter"
              label="Filter By Order Date"
              onDatesChange={handleDateChange}
              startDate={dateFrom ? moment(dateFrom) : null}
              onRemove={onDateClear}             
              
            />
              <FilterMultiSelectChip
                dataTestId="multi-select-status-chip"
                data-testid="multi-select-status-chip"
                selectedValues={selectedStatus}
                icon={<IconFilterList />}
                options={options}
                onSelect={handleStatusFilter}
                prefix="Transmission Status" // Static prefix text
                maxHeight="250px"
              />
            
              <FilterMultiSelectChip
                dataTestId="multi-select-status-chip2"
                data-testid="multi-select-status-chip2"
                selectedValues={selectedFlag}
                icon={<IconFilterList />}
                options={importantOptions}
                onSelect={handleImportantFilter}
                prefix="VDI" // Static prefix text
                maxHeight="250px"
              />
            </div>
            
          </Column>
                
        </Row>
      </Grid>
    </SimpleTableToolbar>
  );
};

export default TableToolbar;
